import { CashOrderSendStatusEnum } from "@/entities";

export enum CashOrderApprovalStatusEnum {
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
  EXPIRED = "EXPIRED",
}

export interface ICashOrderDTO {
  id: number;
  approvalStatus: CashOrderApprovalStatusEnum;
  approvalDate?: string | Date;
  user: ICashOrderUserDTO;
  message: string;
  createdAt: string | Date;
  updatedAt?: string | Date;
  serviceDate?: string | Date;
  productCode: string;
  serviceCode?: string;
  commentsUpdated?: string;
  servicePoint?: ICashOrderServicePointDTO;
  sendStatus?: CashOrderSendStatusEnum;
  // new fields
  createdBy?: string;
  servicepoint?: string;
  retryCount?: number;
  lastError?: string;
  sentAt?: string;
  sendStatusDescription?: string;
}

export interface ICashOrderUserDTO {
  id: number;
  username: string;
  email: string;
}

export interface ICashOrderServicePointDTO {
  id: number;
  oidSol: string;
  codeSol?: string;
  description?: string;
  subclient?: ICashOrderSubclientDTO;
}

export interface ICashOrderSubclientDTO {
  id: number;
  oidSol: string;
  codeSol?: string;
  description?: string;
  client?: ICashOrderClientDTO;
}

export interface ICashOrderClientDTO {
  id: number;
  oidSol: string;
  codeSol?: string;
  description?: string;
}

export interface IApprovalsFilterModel {
  approvalStatus?: CashOrderApprovalStatusEnum[];
  username?: string;
  serviceCode?: string;
  orderDateFrom: Date;
  orderDateTo: Date;
}

export interface IMonitorsFilterModel {
  countries?: string[];
  sendStatuses?: CashOrderSendStatusEnum[];
  serviceCode?: string;
  clientCodeOrDesc?: string;
  usernameOrId?: string;
  subclientCodeOrDesc?: string;
  servicepointCodeOrDesc?: string;
}
